import {axios} from "./config"
export class User extends axios{
   axios;
   token;
   constructor(){
   super();
   this.axios=this.axiosConfig();
 }
 async add(data){
    let formData=new FormData();
    for(let key in data){
        formData.append(key,data[key])
    }
        try{
        let result=await this.axios({
        method:"post",
        url:"user",
        data:formData
    });
        return new Promise((res,rej)=>{
            res(result.data);
        })
        }catch(e){
            return new Promise((res,rej)=>{
                rej(e);
            })
          
        }
          }
          async update(data){
            let formData=new FormData();
            for(let key in data){
                formData.append(key,data[key])
            }
                try{
                let result=await this.axios({
                method:"patch",
                url:"user",
                data:formData
            });
                return new Promise((res,rej)=>{
                    res(result.data);
                })
                }catch(e){
                    return new Promise((res,rej)=>{
                        rej(e);
                    })
                  
                }
                  }
                  async delete(data){
   
                    try{
                    let result=await this.axios({
                    method:"delete",
                    url:"user",
                    data
                    
                });
                    return new Promise((res,rej)=>{
                        res(result.data);
                    })
                    }catch(e){
                        return new Promise((res,rej)=>{
                            rej(e);
                        })
                      
                    }
                }
                 async get(){
                   
                        try{
                        let result=await this.axios({
                        method:"get",
                        url:"user",
                        
                    });
                        return new Promise((res,rej)=>{
                            res(result.data);
                        })
                        }catch(e){
                            return new Promise((res,rej)=>{
                                rej(e);
                            })
                          
                        }
                }
       
                                                          
        
}